























import Vue, { PropType } from "vue";
import { ExternalProvider } from "@/models/providerAccount";
import {
  openLoginPopup,
  openZoomLoginWithLogout,
} from "@/services/externalProvidersService";

export default Vue.extend({
  name: "SafariLoginDialog",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: [String, null] as PropType<ExternalProvider | null>,
      default: null,
    },
    pendingLoginUrl: {
      type: String,
      required: false,
    },
    callback: {
      type: Function as PropType<() => Promise<any>>,
      required: false,
    },
  },
  computed: {
    dialogOpen: {
      get(): boolean {
        return this.value !== null;
      },
      set(open: boolean) {
        if (!open) {
          this.$emit("input", null);
        }
      },
    },
  },
  methods: {
    onCancel() {
      this.$emit("input", null);
      this.$emit("cancel");
    },
    onLoginDialogConfirm() {
      if (this.pendingLoginUrl && this.value) {
        if (this.value === "Zoom") {
          openZoomLoginWithLogout(this.pendingLoginUrl, this.callback);
        } else {
          openLoginPopup(this.pendingLoginUrl, this.callback);
        }
        this.onCancel();
      }
    },
  },
});
